module.exports = __webpack_public_path__ + "static/media/linkedln.c0d23088.svg";